import React, { Component } from 'react';
import { Link, NavLink } from 'react-router-dom';

class NavbarV2 extends Component {

	render() {
		let publicUrl = process.env.PUBLIC_URL + '/';
		let imgattr = 'logo';

		return (
			<header className="site-header-two site-header-two__ go-top go-top">
				<nav className="main-nav__two stricky">
					<div className="container">

						<div className="main-nav__logo-box">
							<Link to="/">
								<img
									className="image-20"
									src={publicUrl + "assets/images/logo/brand-1.png"}
									alt={imgattr}
								/>
							</Link>
						</div>

						<div className="main-nav__main-navigation">
							<ul className="main-nav__navigation-box">

								<li>
									<NavLink
										exact
										to="/"
										activeClassName="current"
									>
										Home
									</NavLink>
								</li>

								<li>
									<NavLink
										to="/about"
										activeClassName="current"
									>
										About
									</NavLink>
								</li>

								<li>
									<NavLink
										to="/service"
										activeClassName="current"
									>
										Services
									</NavLink>
								</li>

								<li>
									<NavLink
										to="/pricing"
										activeClassName="current"
									>
										Pricing
									</NavLink>
								</li>

								<li>
									<NavLink
										to="/contact"
										activeClassName="current"
									>
										Contact
									</NavLink>
								</li>

							</ul>
						</div>

						<div className="main-nav__right">
							<a href="#!" className="side-menu__toggler">
								<span />
							</a>
						</div>

					</div>
				</nav>
			</header>
		);
	}
}

export default NavbarV2;